import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import Tooltip from '@/components/Tooltip';
import Bar from './Bar';
import { getEditingAreaAttr, getEditingAreaMetaDataAttr } from '@/components/Editor/hooks/useEditingAreas';
import styles from '../styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const StackedBarsRow = _ref => {
  let {
    item,
    maximum,
    isLast = false,
    editing = false,
    containerWidth
  } = _ref;
  const {
    label,
    leftAmount,
    rightAmount,
    leftText,
    rightText,
    selectionLeft,
    selectionRight,
    selectionLeftIndex,
    selectionRightIndex,
    tooltip
  } = item;
  const isLeftLesser = leftAmount < rightAmount;
  const isRightLesser = rightAmount < leftAmount;
  const safeDifference = Math.max(1, maximum);
  const isEqualSelection = selectionLeftIndex === selectionRightIndex;
  const isBigSavingsRight = !isLeftLesser ? (leftAmount - rightAmount) / safeDifference >= 0.25 : false;
  const isBigSavingsLeft = isLeftLesser ? (rightAmount - leftAmount) / safeDifference >= 0.25 : false;
  const isBigCostLeft = !isLeftLesser ? (leftAmount - rightAmount) / safeDifference >= 0.25 : false;
  const isBigCostRight = isLeftLesser ? (rightAmount - leftAmount) / safeDifference >= 0.25 : false;
  return /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread(_objectSpread({
    className: clsx(styles.item, isLast ? styles['item--summary'] : '' // TODO refactor for local container height
    // isLast && (containerQueries.isMediumLarge || containerQueries.isLarge)
    //   ? styles['item--summaryHover']
    //   : ''
    )
  }, editing && isEqualSelection && {
    [getEditingAreaAttr()]: `item-${selectionLeftIndex}`
  }), editing && isEqualSelection && {
    [getEditingAreaMetaDataAttr()]: JSON.stringify({
      selection: selectionLeft,
      selectionIndex: selectionLeftIndex
    })
  }), {}, {
    children: [tooltip ? /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      content: tooltip,
      children: /*#__PURE__*/_jsxs("span", {
        className: clsx(styles.resultTitle, styles['resultTitle--tooltip']),
        children: [label, /*#__PURE__*/_jsx(InfoIcon, {
          className: styles.tooltipIcon
        })]
      })
    }) : /*#__PURE__*/_jsx("span", {
      className: clsx(isLast ? styles.summaryTitle : styles.resultTitle),
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.graphic,
      children: [/*#__PURE__*/_jsx(Bar, _objectSpread({
        text: leftText,
        maximum: maximum,
        amount: leftAmount,
        isLastRow: isLast,
        isBigSavings: isBigSavingsLeft,
        isBigCost: isBigCostLeft,
        isLesser: isLeftLesser,
        containerWidth: containerWidth,
        side: "left",
        editing: !isEqualSelection && editing
      }, !isEqualSelection && {
        selection: selectionLeft,
        selectionIndex: selectionLeftIndex
      })), /*#__PURE__*/_jsx(Bar, _objectSpread({
        text: rightText,
        maximum: maximum,
        amount: rightAmount,
        isLastRow: isLast,
        isBigSavings: isBigSavingsRight,
        isBigCost: isBigCostRight,
        isLesser: isRightLesser,
        containerWidth: containerWidth,
        side: "right",
        editing: !isEqualSelection && editing
      }, !isEqualSelection && {
        selection: selectionRight,
        selectionIndex: selectionRightIndex
      }))]
    })]
  }));
};

export default StackedBarsRow;